<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'feather icon-plus'"
                [cardOptionBtn]="false" [title]="'global.overview'|translate">
        <app-grid [grid]="grid"></app-grid>
      </app-card>
    </div>
  </div>
</div>


<ng-template #modelTooltip let-row="row" let-value="value" let-column="column">
  <span class="tooltip-item" *ngIf="true">
    <span class="tooltipBox">
      {{row.message}}
    </span>
    <span class="desc-place" *ngIf="row.message && row.message.length > 100">
      <span>
        {{row.message}}
      </span>
    </span>
  </span>
</ng-template>

<app-modal-basic #viewDifference [dialogClass]="'modal-xl'" [hideFooter]="true">
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'admin.exact.crm_compare' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="onCloseCompareModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ngx-datatable
      class="data-table ngx-datatable"
      [rows]="rows"
      [columns]="columns"
      [footerHeight]="0"
      [rowHeight]="'auto'"
      [headerHeight]="50"
      [messages]="{emptyMessage: 'admin.exact.no_difference' | translate}"
    >
    <ngx-datatable-column 
      *ngFor="let column of columns" 
      [prop]="column.prop" 
      [name]="column.name" [width]="column.width">
    </ngx-datatable-column>
    </ngx-datatable>
  </div>
</app-modal-basic>